import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Lottie from 'lottie-react';
import butterflyAnimation from '../assets/animations/butterfly-animation.json';
interface PreloaderProps {
  onComplete: () => void;
}
export function Preloader({
  onComplete
}: PreloaderProps) {
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(onComplete, 500); // Wait for exit animation
    }, 2500);
    return () => clearTimeout(timer);
  }, [onComplete]);
  return <AnimatePresence data-id="element-365">
      {isVisible && <motion.div initial={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.5
    }} className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#0f0f1a] text-white" data-id="element-366">

          <div className="relative w-32 h-32 mb-8" data-id="element-367">
            <Lottie animationData={butterflyAnimation} loop autoplay className="w-full h-full drop-shadow-[0_0_15px_rgba(220,38,38,0.5)]" data-id="element-368" />
          </div>

          <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }} className="text-center" data-id="element-369">

            <h1 className="font-heading text-2xl font-bold tracking-[0.2em] mb-2" data-id="element-370">
              YAVUZ <span className="text-red-600" data-id="element-371">BURAK</span>
            </h1>
            <div className="flex items-center justify-center gap-2" data-id="element-372">
              <div className="w-1 h-1 bg-red-600 rounded-full animate-bounce" style={{
            animationDelay: '0s'
          }} data-id="element-373" />

              <div className="w-1 h-1 bg-red-600 rounded-full animate-bounce" style={{
            animationDelay: '0.2s'
          }} data-id="element-374" />

              <div className="w-1 h-1 bg-red-600 rounded-full animate-bounce" style={{
            animationDelay: '0.4s'
          }} data-id="element-375" />

            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}